module.exports = __webpack_public_path__ + "static/media/penguin-fishing.d5c82c5f.png";